import React from 'react';

import { ROUTES } from 'src/constants';
import { Text, Link, BaseButton } from 'src/kit';
import { SignInModal } from '../SignInModal';

export const EmailTaken = () => {
  const [showSignInModal, setShowSignInModal] = React.useState(false);

  return (
    <>
      {showSignInModal && (
        <SignInModal onClose={() => setShowSignInModal(false)}>
          {{
            footer: (
              <Link to={ROUTES.forgotPassword} mt={20} variant="auth">
                Forgot your password?
              </Link>
            )
          }}
        </SignInModal>
      )}
      <Text>
        This email address is already used. It means you already applied through the Sainoo recruiting system. Please{' '}
        <Link as={BaseButton} onClick={() => setShowSignInModal(true)} variant="auth" display="inline">
          login
        </Link>{' '}
        or{' '}
        <Link to={ROUTES.forgotPassword} variant="auth" display="inline">
          recover your password
        </Link>
        .
      </Text>
    </>
  );
};
